import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "components/ui/form";
import SingleDatePicker from "components/input-range-data";

interface FilterDateProps {
  control: any;
  errors: any;
}

const formatDateToString = (date: Date | undefined): string => {
  if (!date) return "";
  
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

const parseDate = (dateString: string): Date | undefined => {
  if (!dateString) return undefined;
  
  const parts = dateString.split("/");
  if (parts.length !== 3) return undefined;
  
  const day = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1;
  const year = parseInt(parts[2], 10);
  
  if (isNaN(day) || isNaN(month) || isNaN(year)) return undefined;
  
  const date = new Date(year, month, day);
  
  if (
    date.getDate() !== day ||
    date.getMonth() !== month ||
    date.getFullYear() !== year
  ) {
    return undefined;
  }
  
  return date;
};

export function FilterDate({ control }: FilterDateProps) {
  return (
    <FormField
      control={control}
      name="date"
      render={({ field }) => (
        <FormItem className="space-y-2">
          <FormLabel className="block text-sm font-medium text-gray-700">
            Data *
          </FormLabel>
          <FormControl>
            <SingleDatePicker
              id="filter-date"
              date={parseDate(field.value)}
              onDateChange={(date) => {
                field.onChange(formatDateToString(date));
              }}
              className="[&>div]:gap-0"
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}